/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../../clients/baseClient'
import type { RequestConfig, ResponseErrorConfig } from '../../../../clients/baseClient'
import type {
  ReplyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetQueryResponse,
  ReplyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetPathParams,
  ReplyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetQueryParams,
  ReplyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetHeaderParams,
  ReplyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGet422,
} from '../../types/ReplyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGet.ts'
import type { InfiniteData, QueryKey, QueryClient, InfiniteQueryObserverOptions, UseInfiniteQueryResult } from '@tanstack/react-query'
import { infiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query'

export const replyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetInfiniteQueryKey = (
  thread_id: ReplyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetPathParams['thread_id'],
  params?: ReplyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetQueryParams,
) => [{ url: '/api/v1/reply_schedule/thread/:thread_id', params: { thread_id: thread_id } }, ...(params ? [params] : [])] as const

export type ReplyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetInfiniteQueryKey = ReturnType<
  typeof replyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetInfiniteQueryKey
>

/**
 * @summary Reply Schedule In Thread List
 * {@link /api/v1/reply_schedule/thread/:thread_id}
 */
export async function replyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetInfinite(
  thread_id: ReplyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetPathParams['thread_id'],
  params?: ReplyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetQueryParams,
  headers?: ReplyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ReplyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetQueryResponse,
    ResponseErrorConfig<ReplyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGet422>,
    unknown
  >({ method: 'GET', url: `/api/v1/reply_schedule/thread/${thread_id}`, params, ...requestConfig, headers: { ...headers, ...requestConfig.headers } })
  return res.data
}

export function replyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetInfiniteQueryOptions(
  thread_id: ReplyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetPathParams['thread_id'],
  params?: ReplyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetQueryParams,
  headers?: ReplyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = replyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetInfiniteQueryKey(thread_id, params)
  return infiniteQueryOptions<
    ReplyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetQueryResponse,
    ResponseErrorConfig<ReplyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGet422>,
    ReplyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetQueryResponse,
    typeof queryKey,
    number
  >({
    enabled: !!thread_id,
    queryKey,
    queryFn: async ({ signal, pageParam }) => {
      config.signal = signal

      if (params) {
        params['offset'] = pageParam as unknown as ReplyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetQueryParams['offset']
      }
      return replyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetInfinite(thread_id, params, headers, config)
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage, _allPages, lastPageParam) => (Array.isArray(lastPage) && lastPage.length === 0 ? undefined : lastPageParam + 1),
    getPreviousPageParam: (_firstPage, _allPages, firstPageParam) => (firstPageParam <= 1 ? undefined : firstPageParam - 1),
  })
}

/**
 * @summary Reply Schedule In Thread List
 * {@link /api/v1/reply_schedule/thread/:thread_id}
 */
export function useReplyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetInfinite<
  TData = InfiniteData<ReplyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetQueryResponse>,
  TQueryData = ReplyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetQueryResponse,
  TQueryKey extends QueryKey = ReplyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetInfiniteQueryKey,
>(
  thread_id: ReplyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetPathParams['thread_id'],
  params?: ReplyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetQueryParams,
  headers?: ReplyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetHeaderParams,
  options: {
    query?: Partial<
      InfiniteQueryObserverOptions<
        ReplyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetQueryResponse,
        ResponseErrorConfig<ReplyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGet422>,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {},
) {
  const { query: { client: queryClient, ...queryOptions } = {}, client: config = {} } = options ?? {}
  const queryKey = queryOptions?.queryKey ?? replyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetInfiniteQueryKey(thread_id, params)

  const query = useInfiniteQuery(
    {
      ...replyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetInfiniteQueryOptions(thread_id, params, headers, config),
      queryKey,
      ...queryOptions,
    } as unknown as InfiniteQueryObserverOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, ResponseErrorConfig<ReplyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGet422>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}